const SEASON_MONTHS = {
  Winter: ['January', 'February', 'December'],
  Spring: ['March', 'April', 'May'],
  Summer: ['June', 'July', 'August'],
  Fall: ['September', 'October', 'November'],
} as const;

export type SeasonName = keyof typeof SEASON_MONTHS;

export const SEASON_NAMES: readonly SeasonName[] = Object.freeze(
  Object.keys(SEASON_MONTHS) as SeasonName[]
);

const [winter, spring, summer, fall] = SEASON_NAMES;

export const SEASONS_BY_DESCENDING_END_DATE = [
  winter,
  fall,
  summer,
  spring,
] as const;

export const CALENDAR_MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const;

const winterMonths = SEASON_MONTHS.Winter;

export const WINTER_MONTHS_CHRONOLOGICAL = [
  winterMonths[2],
  winterMonths[0],
  winterMonths[1],
] as const;

export function isSeasonName(name: string): name is SeasonName {
  return SEASON_NAMES.some(seasonName => seasonName === name);
}

export function getSeasonMonths(seasonName: string): readonly string[] {
  return SEASON_MONTHS[seasonName as SeasonName] ?? [];
}

export function isMonthInSeason(month: string, seasonName: string): boolean {
  return getSeasonMonths(seasonName).includes(month);
}

export function makeSeasonId(name: string, year: number): string {
  return `${name.toLowerCase()}-${year}`;
}

export function parseSeasonId(seasonId: string): { name: string; year: number } | null {
  const parts = seasonId.split('-');
  if (parts.length !== 2) {
    return null;
  }

  const name = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
  const year = parseInt(parts[1]);

  if (isNaN(year)) {
    return null;
  }

  return { name, year };
}
